<template>
  <div class="information">
     <!-- <div class="banner">
       <img src="../assets/img/informationbanner.jpg"/>
     </div>-->
     <div class="what informationText">
          <h4>行业资讯</h4>
          <ul class="clear">
             <li v-for="data in $store.state.information.informationText" @click="handleClick(data.ID)">
                <p>{{data.Title}}</p>
                <span>{{data.AddTime}}</span>
             </li>
          </ul>
          <div class="page">
                    <a id='prev' :class="{'active':isactive}" @click="handleprev">上一页</a>
                    <a id="next" :class="{'nextactive':isnextactive}" @click="handlenext">下一页</a>
          </div>
     </div>
     <Popup v-show="$store.state.isshow"></Popup>
  </div>
</template>

<script>
import axios from "axios";
import tool from '@/tool/DataTool'
import router from "@/router"
import Popup from "@/components/popup"
export default {
  name: 'information',
  data () {
    return {
       num:2 ,
       isactive:false,
       isnextactive:true
    }
  },
  components:{
      Popup
  },
  methods:{
     handleClick(id){
         console.log(id)
        router.push(`/informationDetail?id=${id}`);
     },
     handleprev(){
         if(this.num>2){
            this.num-- ;
            this.isactive=true
            this.isnextactive=true
         }else{
           this.num=1;
           this.isactive=false
             this.isnextactive=true
         }
          console.log(this.num)
        this.$store.commit("informationData",this.num)
     },
     handlenext(){
           if(this.num>=this.$store.state.information.pager.PageTotal-1){  
                this.num=this.$store.state.information.pager.PageTotal
                this.isnextactive=false
                this.isactive=true
           }else{
               this.isactive=true
               this.num++ 
           } 
           
           console.log(this.num)
           
        this.$store.commit("informationData",this.num)
     }
  },
  mounted(){ 
        this.$store.commit("informationData",1)
  }
}
</script>
<style scoped>
.information{
    margin-top:0.85rem; 
}
.what.informationText{
    background:#fff;
}
.informationText ul{
    width:6.54rem;
    border-top:0.01rem solid #ccc;
    border-bottom:0.01rem solid #ccc;
    margin:0 auto;
    margin-top:0.56rem;
}
.informationText ul li{
    width:100%;
    padding:0;
    overflow:hidden;
    border-bottom:0.01rem dotted #ccc;
}
.informationText ul li:last-child{
    border:none;
}
.informationText ul li p{
    width:3.64rem;
    float:left;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
    font:0.26rem/0.8rem 'MicrosoftYaHei';
    color:#555;
}
.informationText ul li span{
    float:right;
    font:0.24rem/0.8rem 'MicrosoftYaHei';
    color:#999;
}
.page{
    width:100%;
}
.page a{
    display:inline-block;
    width:1.4rem;
    height:0.6rem;
    margin:0 auto;
    background:#ccc;
    font:0.26rem/0.6rem 'MicrosoftYaHei';
    text-align:center;
    margin-top:0.5rem;
    color:#fff;
}
.page a#prev{
    margin-left:1.92rem;
}
.page a#next{
    margin-left:0.5rem;
}
.page a.active{
   background:#3296fa;
}
.page a.nextactive{
    background:#3296fa;
}
</style>



// WEBPACK FOOTER //
// src/components/information.vue